export default {
  storeNamespace: 'warehouse_transfer',
  authFeature: 'warehouse-transfer',
  listRouteName: "WarehouseTransferList",
  newRouteName: "WarehouseTransferForm",
  detailRouteName: "WarehouseTransferDetail",
  titleField: 'transfer_number',
  sortBy: 'created_at',
  sortDesc: true,
  // Pas d'édition ni de suppression : un transfert se réceptionne ou s'annule (actions
  // de la ligne), et son détail s'ouvre par le numéro.
  hideActionEditButton: true,
  hideActionDeleteButton: true,
  hideActionPdfButton: true,
  hideActionCsvButton: true,
  fields: [
    {
      name: 'transfer_number',
      label: "Numéro",
      type: 'text',
      inList: true,
      sortable: true,
    },
    {
      name: 'created_at',
      label: "Date",
      type: 'text',
      inList: true,
      sortable: true,
    },
    {
      // Filtre seul : période de création du transfert.
      name: 'period',
      label: "Date de création",
      type: 'date',
      extendedFilter: true,
      filterWidth: 'half',
      filterOrder: 1,
    },
    {
      // Filtre seul : un produit (ligne en quantité) ou une référence unique, parmi ceux
      // qui ont déjà été transférés.
      name: 'item',
      label: "Produit / référence unique",
      type: 'autocomplete',
      filterComponent: 'OptionsAutocomplete',
      filterPlaceholder: "Code ou nom…",
      extendedFilter: true,
      filterWidth: 'half',
      filterOrder: 2,
    },
    {
      // Filtre seul : un transfert mixte apparaît sous les deux choix.
      name: 'content',
      label: "Contenu",
      type: 'select',
      extendedFilter: true,
      filterWidth: 'third',
      filterOrder: 3,
    },
    {
      name: 'source_warehouse',
      label: "Source",
      type: 'select',
      inList: true,
      extendedFilter: true,
      filterWidth: 'third',
      filterOrder: 4,
      formatter: (context, value) => value ? value.name : "—",
    },
    {
      name: 'target_warehouse',
      label: "Destination",
      type: 'select',
      inList: true,
      extendedFilter: true,
      filterWidth: 'third',
      filterOrder: 5,
      formatter: (context, value) => value ? value.name : "—",
    },
    {
      name: 'lines_count',
      label: "Lignes",
      type: 'text',
      inList: true,
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inList: true,
      tabFilter: true,
      formatter: (context, value) => value ? value.name : "—",
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/WarehouseTransfer/config.js